import BaseMapper from '../../BaseMapper';

const LeagueMapper = (data, context) => {
    return data;
};

export default LeagueMapper;
